import Input from "@components/common/Input";
import SelectHasMoreMultipleInputs from "@components/common/SelectHasMoreMultipleInputs";
import SelectInput from "@components/common/SelectInput";
import SelectInputClient from "@components/common/SelectInputClient";
import { useFeatureIsOn } from "@growthbook/growthbook-react";
import {
	IS_DISTRIBUTOR_CUSTOMER_ADMIN_ROLE,
	IS_DISTRIBUTOR_CUSTOMER_OPERATOR_ROLE,
	IS_DISTRIBUTOR_CUSTOMER_READONLY_ROLE,
	IS_DISTRIBUTOR_READONLY_ROLE,
	IS_DISTRIBUTOR_ROLE,
	IS_RESELLER_ROLE,
} from "@utils/user_roles";
import { useEffect } from "react";
import { FLAGS } from "../../../config/growthbook/flags.js";

const FormForAdistaT = ({
	currentUserRole,
	id,
	statusId,
	handleStatusChange,
	statusData,
	errors,
	setErrors,
	selectedRoleId,
	handleFormSubmit,
	lastName,
	setLastName,
	firstName,
	setFirstName,
	email,
	setEmail,
	phone,
	setPhone,
	password,
	setPassword,
	confirmPassword,
	setConfirmPassword,
	selectedUnitId,
	setSelectedUnitId,
	name,
	setName,
	distributerId,
	setDistributerId,
	distributor,
	setDistributerName,
	handleBusinessUnitChange,
	selectedParentId,
	setSelectedParentId,
	allBusinessList,
	filteredClients,
	filteredVessels,
	userNotification,
	handleEnableUserChange,
	clientsByDistribuer = [],
	fetchClientsForDistributor,
	loadingClientDist,
	clientAccess,
	handleClientAccessDistChange,
	clientId,
	setClientId,
	handleClientsChange,
	filteredResellers,
	fetchResellersForDist,
	loadingResellerDist,
	resellerId,
	handleResellersChange,
	setClientAccess,
	handleClearInput,
	vesselAccess,
	handleVesselChange,
	vesselName,
	handleVesselAccessChange,
	filteredClientsReseller,
	loadingClientsReseller,
	hasMore,
	loader,
	selectedVessels,
	handleSearchSelectChange,
	fetchMoreData,
	setPageVessel,
	clients,
	handleSearchSelectChangeClient,
	hasMoreClient,
	loaderClient,
	fetchMoreDataClient,
	selectedClientName,
	isMobile,
	handleDistributersChange,
	filteredDistributers,
	buName,
	enableActivation,
	handleEnableActivationChange,
}) => {
	useEffect(() => {
		if (allBusinessList.length === 1) {
			setSelectedUnitId(allBusinessList[0].id);
			setName(allBusinessList[0].name);
			selectedRoleId === IS_DISTRIBUTOR_ROLE || selectedRoleId === IS_DISTRIBUTOR_READONLY_ROLE
				? setDistributerId(distributor.id)
				: null;
			selectedRoleId === IS_DISTRIBUTOR_ROLE || selectedRoleId === IS_DISTRIBUTOR_READONLY_ROLE
				? setDistributerName(distributor.name)
				: null;
			setClientAccess(true);
		}
	}, [selectedRoleId]);

	const distributorFieldVisible = useFeatureIsOn(FLAGS.vessels.form.distributorFieldVisible);
	const activationEnabledVisible = useFeatureIsOn(FLAGS.vessels.form.activationEnabledVisible);

	return (
		<div className="w-full rounded-lg border border-gray-700 bg-navbar-bg p-6 text-start shadow">
			<form className="space-y-6">
				<span className="font-semibold text-normal text-white">Informations</span>
				{!selectedRoleId && (
					<div className="w-full rounded-lg border border-blue-gray bg-navbar-bg p-4 text-start shadow">
						<span className="font-semibold text-normal text-yellow-500">
							Please select a role first:
						</span>
						<p className="text-gray-300">
							To avoid losing any entered data, make sure to select a role before filling out the
							other fields.
						</p>
					</div>
				)}
				{/* Status Field */}
				<div>
					<label className="items-center font-medium text-gray-400 text-sm">
						Status<span className="ml-1 text-gray-400">*</span>
					</label>
					<SelectInput
						id="status"
						placeholder="Status"
						dataTestId="status-select"
						// label=""
						value={statusId}
						onChange={handleStatusChange}
						options={statusData}
						displayField="status"
						className={`mb-2 block w-full rounded-lg border border-gray-600 bg-gray-700 py-3 text-gray-400 text-sm placeholder-gray-400 focus:border-primary-500 focus:ring-primary-500 ${
							errors?.statusId ? "border-red-500" : ""
						}`}
						required
						marginTop={`${isMobile ? "mt-2" : "mt-16"}`}
						classDropdown={`${isMobile ? "relative  " : "absolute z-50"}`}
					/>
					{errors?.statusId && <p className="mt-1 text-red-500 text-sm">{errors.statusId}</p>}
				</div>
				{/* Last name Field */}
				<div>
					<label className="items-center font-medium text-gray-400 text-sm">
						Last name<span className="ml-1 text-gray-400">*</span>
					</label>
					<Input
						id="lastName"
						placeholder="Last name"
						value={lastName}
						onChange={(value) => {
							setLastName(value);
							setErrors((prevErrors) => ({
								...prevErrors,
								lastName: "",
							}));
						}}
						onClear={() => handleClearInput("lastName")}
						className={`input-bg mb-2 block w-full rounded-lg border border-gray-600 py-3 text-gray-400 text-sm placeholder-gray-400 focus:border-primary-500 focus:ring-primary-500 ${
							errors?.lastName ? "border-red-500" : ""
						}`}
						required
					/>
					{errors?.lastName && <p className="text-red-500 text-sm">{errors?.lastName}</p>}
				</div>
				{/* First name Field */}
				<div>
					<label className="items-center font-medium text-gray-400 text-sm">
						First name<span className="ml-1 text-gray-400">*</span>
					</label>
					<Input
						id="firstName"
						placeholder="First name"
						value={firstName}
						onChange={(value) => {
							setFirstName(value);
							setErrors((prevErrors) => ({
								...prevErrors,
								firstName: "",
							}));
						}}
						onClear={() => handleClearInput("firstName")}
						className={`input-bg mb-2 block w-full rounded-lg border border-gray-600 py-3 text-gray-400 text-sm placeholder-gray-400 focus:border-primary-500 focus:ring-primary-500 ${
							errors?.firstName ? "border-red-500" : ""
						}`}
						required
					/>
					{errors?.firstName && <p className="text-red-500 text-sm">{errors?.firstName}</p>}
				</div>
				{/* Email Field */}
				<div>
					<label className="items-center font-medium text-gray-400 text-sm">
						Email<span className="ml-1 text-gray-400">*</span>
					</label>
					<Input
						id="email"
						placeholder="Email"
						type="email"
						value={email}
						onChange={(value) => {
							setEmail(value);
							setErrors((prevErrors) => ({
								...prevErrors,
								email: "",
							}));
						}}
						onClear={() => handleClearInput("email")}
						className={`input-bg mb-2 block w-full rounded-lg border border-gray-600 py-3 text-gray-400 text-sm placeholder-gray-400 focus:border-primary-500 focus:ring-primary-500 ${
							errors?.email ? "border-red-500" : ""
						}`}
						required
					/>
					{errors?.email && <p className="text-red-500 text-sm">{errors?.email}</p>}
				</div>
				{/* Password Field */}
				{!id && (
					<div>
						<label className="items-center font-medium text-gray-400 text-sm">
							Password<span className="ml-1 text-gray-400">*</span>
						</label>
						<Input
							id="password"
							placeholder="Password"
							value={password}
							onChange={(value) => {
								setPassword(value);
								setErrors((prevErrors) => ({
									...prevErrors,
									password: "",
								}));
							}}
							// isDisabled={true} // Conditionally disable the input
							onClear={() => handleClearInput("password")}
							className={`input-bg mb-2 block w-full rounded-lg border border-gray-600 py-3 text-gray-400 text-sm placeholder-gray-400 focus:border-primary-500 focus:ring-primary-500 ${
								errors?.password ? "border-red-500" : ""
							}`}
							required
						/>
						{errors?.password && <p className="text-red-500 text-sm">{errors?.password}</p>}
					</div>
				)}

				{/* distributor Field */}
				{(selectedRoleId === IS_RESELLER_ROLE || selectedParentId === IS_RESELLER_ROLE) &&
					selectedUnitId &&
					distributorFieldVisible && (
						<>
							<SelectInput
								id="distributors"
								dataTestId="distributors-select"
								placeholder="Select a Distributor"
								label="Distributors *"
								value={distributerId}
								onChange={handleDistributersChange}
								options={filteredDistributers.map((dist) => ({
									id: dist.id,
									name: dist.name,
								}))}
								displayField="name"
								className={`block w-full rounded-lg border border-gray-600 bg-gray-700 py-3 text-gray-400 text-sm placeholder-gray-400 focus:border-primary-500 focus:ring-primary-500 ${
									errors.distributerId ? "border-red-500" : ""
								}`}
								required
								marginTop={`${isMobile ? "mt-2" : "mt-20"}`}
								classDropdown={`${isMobile ? "relative  " : "absolute z-50"}`}
							/>
							{errors.distributerId && (
								<p className="text-red-500 text-sm">{errors.distributerId}</p>
							)}
						</>
					)}
				{/* Client Access Field As Distributor */}
				{(selectedRoleId === IS_DISTRIBUTOR_CUSTOMER_ADMIN_ROLE ||
					selectedRoleId === IS_DISTRIBUTOR_CUSTOMER_OPERATOR_ROLE ||
					selectedRoleId === IS_DISTRIBUTOR_CUSTOMER_READONLY_ROLE) && (
					<>
						<SelectInputClient
							id="clientSelectdist"
							placeholder="Select a Client"
							label="Clients *"
							value={clientId}
							onChange={handleClientsChange}
							options={clientsByDistribuer}
							displayField="name"
							search={handleSearchSelectChangeClient}
							fetchMoreData={() => fetchMoreDataClient()}
							hasMore={hasMoreClient}
							loader={loaderClient}
							required
							selectedItems={selectedClientName}
							marginTop={`${isMobile ? "mt-2" : "mt-20"}`}
							classDropdown={`${isMobile ? "relative  " : "absolute z-50"}`}
						/>
						{errors.clientId && <p className="text-red-500 text-sm">{errors.clientId}</p>}
					</>
				)}

				{clientsByDistribuer?.length > 0 &&
					clientId &&
					selectedUnitId &&
					(selectedRoleId === IS_DISTRIBUTOR_CUSTOMER_ADMIN_ROLE ||
						selectedRoleId === IS_DISTRIBUTOR_CUSTOMER_OPERATOR_ROLE ||
						selectedRoleId === IS_DISTRIBUTOR_CUSTOMER_READONLY_ROLE) && (
						<>
							<div className="flex items-center">
								<input
									id="link-checkbox-vess-access"
									type="checkbox"
									checked={vesselAccess}
									onChange={handleVesselAccessChange}
									className="h-4 w-4 rounded border-blue-gray bg-blue-gray text-blue-gray ring-offset-dark-blue focus:ring-2 focus:ring-dark-blue"
								/>
								<label htmlFor="link-checkbox-vess-access" className="ms-2 text-gray-400">
									Enable Vessel Access
								</label>
							</div>

							{vesselAccess && clientId && (
								<>
									<SelectHasMoreMultipleInputs
										id="siteName"
										placeholder="Select one or more site name"
										label="Site Name *"
										value={vesselName}
										onChange={handleVesselChange}
										options={filteredVessels.map((vessel) => ({
											id: vessel.id,
											name: vessel.site_name,
										}))}
										displayField="name"
										fetchMoreData={() => fetchMoreData()}
										hasMore={hasMore}
										loader={loader}
										selectedItems={selectedVessels}
										search={handleSearchSelectChange}
										attr="site_name"
										marginTop={`${isMobile ? "mt-2" : "mt-20"}`}
										classDropdown={`${isMobile ? "relative  " : "absolute z-50"}`}
									/>
									{errors.vesselName && <p className="text-red-500 text-sm">{errors.vesselName}</p>}
								</>
							)}
						</>
					)}
				{/* Enable Activation Field */}
				{activationEnabledVisible && currentUserRole?.id === IS_DISTRIBUTOR_ROLE && (
					<div className="flex items-center">
						<input
							id="link-checkbox-activation"
							type="checkbox"
							checked={enableActivation}
							onChange={handleEnableActivationChange}
							className="h-4 w-4 rounded border-blue-gray bg-blue-gray text-blue-gray ring-offset-dark-blue focus:ring-2 focus:ring-dark-blue"
						/>
						<label htmlFor="link-checkbox-activation" className="ms-2 text-gray-400">
							Enable Activation
						</label>
					</div>
				)}

				{/* User Notification Field */}
				<div className="flex items-center">
					<input
						id="link-checkbox-notification"
						type="checkbox"
						checked={userNotification}
						onChange={handleEnableUserChange}
						className="h-4 w-4 rounded border-blue-gray bg-blue-gray text-blue-gray ring-offset-dark-blue focus:ring-2 focus:ring-dark-blue"
					/>
					<label htmlFor="link-checkbox-notification" className="ms-2 text-gray-400">
						Enable User Notification
					</label>
				</div>
			</form>
		</div>
	);
};

export default FormForAdistaT;
